import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

const FlashRedirect = ({ addNotification, to, message, ...notificationProps }) => {
    useEffect(() => {
        addNotification({ message, ...notificationProps });
    });

    return <Redirect to={to} />;
};

export default FlashRedirect;
